import { getDataStoreEntityMap } from './dataStoreEntityMap'
import { isIncomingOperatorMessage } from './isIncomingOperatorMessage'

/**
 * Redux put payloads to clear group unread immediately (before/after socket read ack).
 * @param {object} rootState
 * @param {string} chatGroupId
 * @param {string|undefined} profileId
 * @returns {{ chatGroupPatch: { id: string, item: object }|null, messagePatches: Array<{ id: string, patch: object }> }}
 */
export function buildChatGroupUnreadClearPatches (rootState, chatGroupId, profileId) {
  const gid = String(chatGroupId)
  const chatGroupsById = getDataStoreEntityMap(rootState.data.chatGroups)
  const existing = chatGroupsById[gid]
  const messagePatches = []

  if (profileId) {
    const messagesById = getDataStoreEntityMap(rootState.data.messages)
    for (const [id, message] of Object.entries(messagesById)) {
      if (String(message.receiverChatGroupId || '') !== gid) continue
      if (message.read) continue
      if (!isIncomingOperatorMessage(message, profileId)) continue
      messagePatches.push({
        id,
        patch: { read: true, received: true }
      })
    }
  }

  const chatGroupPatch = existing
    ? {
        id: gid,
        item: {
          ...existing,
          nrOfUnreadMessages: 0,
          hasDangerUnread: false
        }
      }
    : null

  return { chatGroupPatch, messagePatches }
}
